import config from './config'
import axios from 'axios'

export const BlobAPI = {
    create: (data, filename, contentType) => {
        let extra = {
            headers: {
                'Content-Disposition': `attachment; filename=${filename}`,
                'Content-Type': contentType,
            },
        }
        return config.post('/api/blob/', data, { ...extra })
    },

    getPresignedUrl: (filename, mimeType) => {
        let body = {
            filename: filename,
            mime_type: mimeType,
        }

        return config.post('/api/blob/presigned_urls/', body)
    },

    getPresignedUrlV2: (data) => {
        return config.post('/api/blob/presigned_urls_v2/', { files: data })
    },

    uploadBlob: (presignedPostObj, file, onUploadProgress) => {
        const formData = new FormData()

        Object.entries(presignedPostObj.fields).forEach(([key, value]) => {
            formData.append(key, value)
        })
        formData.append('file', file)

        return axios.post(presignedPostObj.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: onUploadProgress,
        })
    },
}
